import { get } from 'lodash';
import React from 'react';
import { OriCheckbox, OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ResponsiveAnimation,
  ResponsiveContentText,
  ResponsiveModuleStyle,
} from 'src/components/Modules/Components';
import Switcher from 'src/components/SectionSwitcher';
import AutoPlay from 'src/constrains/SalesChannelPreviewPageComponents/AutoPlay';
import {
  EModuleWidth,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveContentPageToShow,
} from 'src/types/common/module';
import css from './css.module.less';
const Option = OriSelect.Option;
//import { uuid } from '@/src/tools/helper';
import _ContentPage from 'src/components/Modules/Components/ContentImageDragItem';
import { errKeys as contentErr } from 'src/components/Modules/Components/ContentImageDragItem/tools';
import { moduleStyleProps } from 'src/components/Modules/Components/ModuleStyle/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ResponsiveContentCarousel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //console.log(props);
  const {
    onItemAdd,
    onItemChange,
    onItemDelete,
    onItemSort,
    onStaticChange,
    contentPages,
    contentPageList,
    specificError,
    staticData,
    animations,
    hoverAnimations,
    //buttons,
    isConvertible,
  } = props;

  const hasContentPagesAmountError =
    get(specificError, 'contentPages', []).length > 0 ||
    get(specificError, 'contentPageToShowMismatchError', []).length > 0;

  const draggableId = get(staticData, 'draggableId');
  const contentPagesToShow = get(staticData, 'contentPagesToShow');
  const animation = get(staticData, 'animation');
  const autoPlay = get(staticData, 'autoPlay');
  const intervalTime = get(staticData, 'intervalTime');
  const moduleStyle = get(staticData, 'moduleStyle');
  const moduleWidth = get(staticData, 'moduleWidth');
  const leaveGap = get(staticData, 'leaveGap');
  const scrollOut = get(staticData, 'scrollOut');

  //const actionButtonTheme = get(staticData, 'actionButtonTheme') || null;
  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;
  const text = get(staticData, 'moduleText');
  // const handleOnActionButtonThemeChange = (actionButtonTheme) => {
  //   onStaticChange({ actionButtonTheme });
  // };

  const dict = {
    [EResponsiveContentPageToShow.One]: 1,
    [EResponsiveContentPageToShow.TwoLandscape]: 2,
    [EResponsiveContentPageToShow.TwoPortrait]: 2,
    [EResponsiveContentPageToShow.Three]: 3,
    [EResponsiveContentPageToShow.Four]: 4,
    [EResponsiveContentPageToShow.Five]: 5,
    [EResponsiveContentPageToShow.Six]: 6,
  };

  const generateScrolledOut = () => {
    const all = [
      <Option value={1} key={'1'}>
        {getI18n('general.oneContentPageEachScroll')}
      </Option>,
      <Option value={2} key={'2'}>
        {getI18n('general.twoContentPagesEachScroll')}
      </Option>,
      <Option value={3} key={'3'}>
        {getI18n('general.threeContentPagesEachScroll')}
      </Option>,
      <Option value={4} key={'4'}>
        {getI18n('general.fourContentPagesEachScroll')}
      </Option>,
      <Option value={5} key={'5'}>
        {getI18n('general.fiveContentPagesEachScroll')}
      </Option>,
      <Option value={6} key={'6'}>
        {getI18n(' general.sixContentPagesEachScroll')}
      </Option>,
    ];
    const mostNumber = dict[contentPagesToShow] || 0;
    const a = all.slice(0, mostNumber);
    return a;
  };

  const isOneContentPageOnScreen =
    contentPagesToShow === EResponsiveContentPageToShow.One;

  const handleOnScrollOutChange = (scrollOut) => {
    onStaticChange({ scrollOut });
  };

  const handleOnLeaveGapChange = (e) => {
    const leaveGap = e.target.checked;
    onStaticChange({ leaveGap });
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnAutoPlayChange = (autoPlay) => {
    onStaticChange({ autoPlay });
  };

  const handleOnIntervalChange = (intervalTime) => {
    onStaticChange({ intervalTime });
  };

  const handleOnContentPagesToShowChange = (contentPagesToShow) => {
    const mostNumber = dict[contentPagesToShow];

    if (mostNumber && scrollOut > mostNumber) {
      onStaticChange({ contentPagesToShow, scrollOut: mostNumber });
    } else {
      onStaticChange({ contentPagesToShow });
    }
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleTextChange = (ani) => {
    const newText = { ...(text || {}), ...ani };
    onStaticChange({ moduleText: newText });
  };

  const handleOnItemAdd = () => {
    onItemAdd();
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onItemSort(oldIndex, newIndex);
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const childGenerate = (data, index) => {
    const contentPage = get(data, 'contentPage');
    const summary = get(data, 'summary');
    const image = get(data, 'image');
    const subtitle = get(data, 'subtitle');
    const draggableId = get(data, 'draggableId');

    const _specificError = Object.keys(specificError).reduce((pre, now) => {
      if (now.startsWith(draggableId)) {
        const v = specificError[now];

        const item = now.split(draggableId)[1];
        return { ...pre, [item]: v };
      }
      return pre;
    }, {});

    return (
      <_ContentPage
        isPrimary={true}
        specificError={_specificError}
        errKeys={contentErr}
        index={index}
        contentPageList={contentPageList}
        sectionContainer={css.contentPageSectionContainer}
        contentPage={contentPage}
        image={image}
        summary={summary}
        subtitle={subtitle}
        onChange={onItemChange}
        onDelete={handleOnItemDelete}
      />
    );
  };

  return (
    <React.Fragment>
      {!isConvertible && (
        <Section size='small' bottomBorder className={css.container}>
          <ItemWrapper title={getI18n('general.moduleWidth')}>
            <OriSelect
              size='large'
              value={moduleWidth}
              onChange={handleOnModuleWidthChange}>
              <Option value={EModuleWidth.WIDE}>
                {getI18n('general.wideWidth')}
              </Option>
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            </OriSelect>
          </ItemWrapper>
          <div className={css.autoContainer}>
            <AutoPlay
              isAuto={autoPlay}
              interval={intervalTime}
              interOnChange={handleOnIntervalChange}
              autoOnChange={handleOnAutoPlayChange}
            />
          </div>
        </Section>
      )}

      <Section size='small' bottomBorder>
        <ItemWrapper title={getI18n('general.contentPagesToShow')}>
          <OriSelect
            size='large'
            value={contentPagesToShow}
            onChange={handleOnContentPagesToShowChange}>
            <Option value={EResponsiveContentPageToShow.One}>
              {getI18n('general.oneContentPageOnScreen')}
            </Option>
            <Option value={EResponsiveContentPageToShow.TwoPortrait}>
              {getI18n('general.twoContentPagesOnScreen')}(
              {getI18n('general.portrait')})
            </Option>
            {isConvertible
              ? []
              : [
                  <Option value={EResponsiveContentPageToShow.TwoLandscape}>
                    {getI18n('general.twoContentPagesOnScreen')} (
                    {getI18n('general.landscape')})
                  </Option>,
                  <Option value={EResponsiveContentPageToShow.Three}>
                    {getI18n('general.threeContentPagesOnScreen')}
                  </Option>,
                  <Option value={EResponsiveContentPageToShow.Four}>
                    {getI18n('general.fourContentPagesOnScreen')}
                  </Option>,
                  <Option value={EResponsiveContentPageToShow.Five}>
                    {getI18n('general.fiveContentPagesOnScreen')}
                  </Option>,
                  <Option value={EResponsiveContentPageToShow.Six}>
                    {getI18n('general.sixContentPagesOnScreen')}
                  </Option>,
                ]}
          </OriSelect>
        </ItemWrapper>
        {!isOneContentPageOnScreen && (
          <div className={css.gapContainer}>
            <OriCheckbox checked={leaveGap} onChange={handleOnLeaveGapChange}>
              {getI18n('general.leavegapbetweencontentpages')}
            </OriCheckbox>
          </div>
        )}
        {!isOneContentPageOnScreen && (
          <ItemWrapper title={getI18n('general.scrolledOutContentPagesNumber')}>
            <OriSelect
              size='large'
              value={scrollOut}
              onChange={handleOnScrollOutChange}>
              {generateScrolledOut()}
            </OriSelect>
          </ItemWrapper>
        )}

        {/* <ItemWrapper title='Call To Action Button Theme(Optional)'>
          <OriSelect
            size='large'
            value={actionButtonTheme}
            onChange={handleOnActionButtonThemeChange}>
            <OriSelect.Option value={null}>None</OriSelect.Option>
            {(buttons || []).map((i) => {
              return (
                <OriSelect.Option value={i.uuid} key={i.uuid}>
                  {i.name}
                </OriSelect.Option>
              );
            })}
          </OriSelect>
        </ItemWrapper> */}
      </Section>
      <Section size='small' className={css.switcherContainer}>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ResponsiveModuleStyle
                    {...moduleStyleProps(moduleWidth)}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Text]: {
                    title: getI18n('general.text'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveContentText
                          data={text}
                          onChange={handleTextChange}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.ContentPage]: {
                    title: getI18n('general.sider.contentPage'),
                    hasError: hasContentPagesAmountError,
                    child: (
                      <DragNDropColumns
                        // disabled={!isPrimary}
                        // hideAdd={!isPrimary}
                        hideTitle
                        childGenerate={childGenerate}
                        data={contentPages}
                        droppableId={`salesChannelContentListContentPagesCarousel${draggableId}`}
                        onSort={handleItemOnSort}
                        // hideAdd={hideAdd}
                        onAdd={handleOnItemAdd}
                        addText={`+ ${getI18n('general.addContentPage')}`}
                        //onDelete={handleOnItemDelete}
                      />
                    ),
                  },
                }),
          }}
        />
      </Section>
    </React.Fragment>
  );
};
export default ResponsiveContentCarousel;
